import { pluginApi } from 'services/api';
import { fakeFormatDollars, formatPercent } from 'util/points';
import getDirectors from './getDirectors';
import getRegional from './getRegional';
import { StatisticsWithProduct } from './interfaces/generalStatisticsWithProducts';
import { Product } from '../../state/modules/home/types';

export interface ApiResponse {
  revenues: {
    goal: number;
    result: number;
    percentage: number;
  };
  pog: {
    goal: number;
    result: number;
    percentage: number;
  };
  focus_product: Product[];
}

export interface Filters {
  directorName?: string;
  regionalName?: string;
  campaignId?: number;
}

const transformer = (data: ApiResponse): StatisticsWithProduct => {
  return {
    revenues: {
      ...data.revenues,
      formattedGoal: fakeFormatDollars(data.revenues?.goal, 0, 0),
      formattedResult: fakeFormatDollars(data.revenues?.result, 0, 0),
      formattedPercentage: formatPercent(data.revenues?.percentage),
    },
    pog: {
      ...data.pog,
      formattedGoal: fakeFormatDollars(data.pog.goal, 0, 0),
      formattedResult: fakeFormatDollars(data.pog.result, 0, 0),
      formattedPercentage: formatPercent(data.pog.percentage),
    },
    focus_product: {
      ...data.focus_product,
    },
  };
};

export default async (filters: Filters): Promise<StatisticsWithProduct> => {
  let extraSearch = '';

  if (filters.directorName) {
    extraSearch = `?directorships[0]=${filters.directorName}`;
  }

  if (filters.regionalName) {
    extraSearch += `${extraSearch !== '' ? '&' : '?'}regional[0]=${
      filters.regionalName
    }`;
  }

  /* Temporário até o Robson ajustar a chamada do EndPoint no Back */
  if (!filters.directorName) {
    const directors = await getDirectors();
    extraSearch += extraSearch === '' ? '?' : '&';
    extraSearch += directors
      .map((item, key) => `directorships[${key}]=${item.name}`)
      .join('&');
  }
  if (!filters.regionalName) {
    const regionals = await getRegional();
    extraSearch += `&${regionals
      .map((item, key) => `regional[${key}]=${item.name}`)
      .join('&')}`;
  }

  const currentCampaignId = filters.campaignId;

  if (currentCampaignId) extraSearch += `&campaign_id=${currentCampaignId}`;

  const { data } = await pluginApi.get<ApiResponse>(
    `cockpit/general-statistics${extraSearch}`,
  );
  return transformer(data);
};
